import styles from "./special-offer-card.module.css";

interface OfferFlyerBarProps {
  /** Resolved flyer URL — callers only render this when it's non-empty. */
  file: string;
  /** CMS download title; falls back to a generic label. */
  title?: string | null;
}

/**
 * Download bar for an offer's flyer, shared by the Special-Offers page cards
 * (`SpecialOfferCard`) and the offer strip on the package / destination /
 * region pages (`OffersStrip`) — the same offer must show the same bar
 * wherever its dialog is opened.
 *
 * Pass it to `Dialog`'s `toolbar` slot so it renders outside the scrolling
 * body and stays pinned under the header.
 */
export default function OfferFlyerBar({ file, title }: OfferFlyerBarProps) {
  const label = title?.trim() || "Download Offer Flyer";

  return (
    <a
      href={file}
      className={styles.flyerBar}
      target="_blank"
      rel="noopener noreferrer"
      download
      title={label}
    >
      <i className={`fa-solid fa-file-pdf ${styles.flyerPdfIcon}`} aria-hidden="true" />
      <span className={styles.flyerText}>{label}</span>
      <i className={`fa-solid fa-download ${styles.flyerDlIcon}`} aria-hidden="true" />
    </a>
  );
}
